module.exports = __webpack_public_path__ + "static/media/messageIcon.b3f22a3c.svg";